export default __webpack_public_path__ + "/dist/images/blocking-active.2fff40fc7fa4ff9d8267a3b9279eaed4.svg";